import { HTTPError } from "ky";
import { isErrorEnvelope } from "@/lib/handle-form-error";

export function extractApiError(err: unknown, fallback: string): string {
  if (!(err instanceof HTTPError)) return fallback;
  if (isErrorEnvelope(err.data)) return err.data.errors[0]?.message ?? fallback;
  return fallback;
}
